(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["adl-whatsapp"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const whatsapp = document.querySelector('.adl-whatsapp');
    if (!whatsapp) return;
    const roots = new WeakSet();
    const watched = new WeakSet();
    let launcher;
    let pending = false;
    const resize = new ResizeObserver(() => schedule());
    const observe = root => {
      if (roots.has(root)) return;
      roots.add(root);
      new MutationObserver(() => schedule()).observe(root, {childList:true,subtree:true,attributes:true,attributeFilter:['style','class','hidden']});
    };
    const find = root => {
      observe(root);
      const button = root.querySelector('button.activator');
      if (button) return button;
      for (const element of root.querySelectorAll('*')) {
        if (element.shadowRoot) {
          const result = find(element.shadowRoot);
          if (result) return result;
        }
      }
    };
    const sync = () => {
      pending = false;
      for (const host of document.querySelectorAll('shopify-chat')) {
        if (host.shadowRoot) {
          launcher = find(host.shadowRoot) || launcher;
        }
      }
      if (!launcher?.isConnected) return;
      if (!watched.has(launcher)) {
        watched.add(launcher);
        resize.observe(launcher);
      }
      const rect = launcher.getBoundingClientRect();
      if (rect.width < 20 || rect.height < 20 || rect.bottom > innerHeight + 1 || rect.top < 0) return;
      whatsapp.style.setProperty('--wa-chat-width', rect.width + 'px');
      whatsapp.style.setProperty('--wa-chat-height', rect.height + 'px');
      whatsapp.style.setProperty('--wa-chat-bottom', Math.max(0, innerHeight - rect.bottom) + 'px');
      whatsapp.style.setProperty('--wa-chat-left', Math.max(12, document.documentElement.clientWidth - rect.right) + 'px');
    };
    const schedule = () => {
      if (!pending) {
        pending = true;
        requestAnimationFrame(sync);
      }
    };
    new MutationObserver(schedule).observe(document.body, {childList:true});
    addEventListener('resize', schedule, {passive:true});
    visualViewport?.addEventListener('resize', schedule, {passive:true});
    visualViewport?.addEventListener('scroll', schedule, {passive:true});
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
